export const HIDE_ELEMENT_TRIGGER_ID = 'hide-element';
